<template>
	<div class="filters-box">
		<div v-for="filter in filters" :key="filter.key" class="filter-item-box">
			<div class="filter-item" v-if="filter.list && filter.list.length > 0">
				<div class="label">{{ filter.label }}</div>
				<div :class="['filter-box', expands[filter.key] ? 'expand-all' : '']" :ref="filter.key">
					<div
						:class="['item-name', form[filter.key] === item.value ? 'active' : '']"
						v-for="(item, index) in filter.list"
						:key="index"
						@click="select(filter.key, item.value)"
					>
						{{ item.label }}
					</div>
				</div>
				<div v-if="filter.show" :class="['more', expands[filter.key] ? 'expand' : '']" @click="expand(filter.key)">
					{{ expands[filter.key] ? '收起' : '展开' }}
					<i class="el-icon-arrow-down"></i>
				</div>
			</div>
		</div>
		<div class="filter-item-box" v-if="$isPlatOr(['Dy', 'Ks'])">
			<div class="filter-item">
				<div class="label">带货数据</div>
				<div class="filter-box" style="height: 28px">
					<el-select size="mini" multiple collapse-tags v-model="form.live_sale" clearable placeholder="场均销售额">
						<el-option :label="item.itemName" :value="item.itemValue" v-for="(item, index) in liveSale" :key="index" />
					</el-select>
					<div v-show="$isDy(platformId)">
						<el-select size="mini" v-model="form.anchor_level" placeholder="达人等级">
							<el-option :label="item.label" :value="item.value" v-for="(item, index) in talentGradeList" :key="index" />
						</el-select>
					</div>
					<div v-show="$isKs(platformId)">
						<el-select size="mini" multiple collapse-tags v-model="form.fee_30" clearable placeholder="30日销售额" class="tags-select-input">
							<el-option :label="item.itemName" :value="item.itemValue" v-for="(item, index) in fee30" :key="index" />
						</el-select>
						<el-select size="mini" multiple collapse-tags v-model="form.video_sale" clearable placeholder="单视频销售额" class="tags-select-input">
							<el-option :label="item.itemName" :value="item.itemValue" v-for="(item, index) in videoSale" :key="index" />
						</el-select>
						<el-select size="mini" multiple v-model="form.avg_price" clearable placeholder="带货商品均价" class="tags-select-input">
							<el-option :label="item.itemName" :value="item.itemValue" v-for="(item, index) in avgPrice" :key="index" />
						</el-select>
					</div>
				</div>
			</div>
		</div>
		<div class="filter-item-box" v-if="$isPlatOr(['Dy', 'Ks'])">
			<div class="filter-item">
				<div class="label">粉丝数据</div>
				<div class="filter-box" style="height: 28px">
					<el-select size="mini" v-model="form.fans_num" clearable placeholder="粉丝量">
						<el-option :label="item.label" :value="item.value" v-for="(item, index) in fansList" :key="index" />
					</el-select>
					<el-select size="mini" multiple collapse-tags v-model="form.fans_age" clearable placeholder="粉丝年龄">
						<el-option :label="item.label" :value="item.value" v-for="(item, index) in fansAgeList" :key="index" />
					</el-select>
					<el-select size="mini" v-model="form.fans_sex" clearable placeholder="粉丝性别">
						<el-option :label="item.label" :value="item.value" v-for="(item, index) in fansSexList" :key="index" />
					</el-select>
					<template v-if="$isDy()">
						<el-select size="mini" multiple collapse-tags v-model="form.fans_city_level" clearable placeholder="粉丝地区">
							<el-option :label="item.label" :value="item.value" v-for="(item, index) in fansAreaList" :key="index" />
						</el-select>
					</template>
				</div>
			</div>
		</div>
		<div class="filter-item-box" v-if="$isSp()">
			<div class="filter-item select">
				<div class="label">带货数据</div>
				<div class="filter-box" style="height: 28px">
					<el-select size="mini" v-model="form.fans_num" filterable clearable placeholder="粉丝数">
						<el-option :label="item.itemName" :value="item.itemValue" v-for="item in fansNum" :key="item.value" />
					</el-select>
					<el-select size="mini" v-model="form.promotion_pro_num" filterable clearable placeholder="30日带货商品数">
						<el-option :label="item.itemName" :value="item.itemValue" v-for="item in promotionProNum" :key="item.value" />
					</el-select>
					<el-select size="mini" v-model="form.fee_30" filterable clearable placeholder="30日销售额">
						<el-option :label="item.itemName" :value="item.itemValue" v-for="item in fee30" :key="item.value" />
					</el-select>
					<el-select size="mini" v-model="form.live_sale" filterable clearable placeholder="场均销售额">
						<el-option :label="item.itemName" :value="item.itemValue" v-for="item in liveSale" :key="item.value" />
					</el-select>
				</div>
			</div>
		</div>
		<div class="filter-item-box select" v-if="$isSp()">
			<div class="filter-item center">
				<div class="label">搜索达人</div>
				<div class="filter-box" style="height: auto">
					<el-input
						style="width: 293px; margin-right: 10px"
						placeholder="请输入达人昵称搜索"
						v-model="form.anchor_name"
						class="prependClass"
					></el-input>
					<el-button type="primary" @click="submit(true)">筛 选</el-button>
					<el-button @click="reset">清 空</el-button>
				</div>
			</div>
		</div>
		<div class="filter-item-box" v-if="$isPlatOr(['Dy', 'Ks'])">
			<div class="filter-item center">
				<div class="label">搜索</div>
				<div class="filter-box" style="height: auto">
					<el-input
						style="width: 400px; margin-right: 10px"
						:placeholder="selectOption == 1 ? '请输入达人昵称' : `请输入${platformName}`"
						suffix-icon="el-icon-search"
						v-model="form.anchor_name"
					>
						<el-select v-model="selectOption" slot="prepend" placeholder="请选择">
							<el-option label="搜昵称" value="1"></el-option>
							<el-option :label="`搜${platformName}`" value="2"></el-option>
						</el-select>
					</el-input>
					<el-button type="primary" @click="submit(true)">筛 选</el-button>
					<el-button @click="reset">清 空</el-button>
				</div>
			</div>
		</div>
		<div class="filter-item-box">
			<div class="filter-item center">
				<div class="label">个性筛选</div>
				<div class="filter-box" style="height: auto">
					<div>
						<el-checkbox v-model="isCooperation" @change="handleCheck">
							<el-dropdown @command="handleCommand">
								<span class="el-dropdown-link hover">
									{{ dropdownText }}
									<i class="el-icon-arrow-down el-icon--right"></i>
								</span>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item command="1">本人未合作</el-dropdown-item>
									<el-dropdown-item command="0">团队未合作</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</el-checkbox>
						<!-- <el-tooltip class="item" effect="dark" :content="content" placement="top">
							<i class="iconfont icon-a-help-circle-obangzhu-xian yx-color-text-regular ml-6 mt-4"></i>
						</el-tooltip> -->
					</div>
					<div class="ml-24" v-if="$isPlatOr(['Dy', 'Ks'])">
						<el-checkbox v-model="form.have_contact" @change="submit(true)" :true-label="1" :false-label="0">有简介联系方式</el-checkbox>
						<Explain class="ml-4" content="联系方式取自达人简介" classStyle="yx-color-text-placeholder" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { fansList, talentGradeList, liveCountList, avgPriceList, fansAgeList, fansSexList, fansAreaList } from '@/utils/dataMap';
import { getPartnerAnchor, clueSelectList } from '@/api/talentCRM';
import Explain from '@/components/common/explain';
export default {
	components: {
		Explain,
	},
	props: {
		platformId: {
			type: [String, Number],
			default: '',
		},
		dyList: {
			type: Array,
			default: _ => [],
		},
		ksList: {
			type: Array,
			default: _ => [],
		},
		spList: {
			type: Array,
			default: _ => [],
		},
	},
	watch: {
		platformId: {
			handler(to) {
				this.clueSelectList();
			},
			immediate: true,
		},
	},
	data() {
		return {
			selectOption: '1',
			form: {
				cate: '',
				fans_num: '',
				fans_age: '',
				fans_sex: '',
				fans_city_level: '',
				anchor_level: -1,
				live_sale: '',
				live_count_90: '',
				avg_price: '',
				anchor_name: '',
				anchor_account: '',
				team_claim: 0,
				partner_claim: 0,
				promotion_pro_num: '',
				fee_30: '',
			},
			expands: {
				cate: false,
			},
			fansList,
			talentGradeList,
			liveCountList,
			avgPriceList,
			fansAgeList,
			fansSexList,
			fansAreaList,
			isCooperation: false,
			dropdownText: '团队未合作',
			many_partner: 0,
			content: '一键筛选团队所有成员均未认领的达人',
			liveSale: [],
			fee30: [],
			videoSale: [],
			avgPrice: [],
			promotionProNum: [], //30日带货商品数，只有视频号有
			fansNum: [],
		};
	},
	computed: {
		platformName() {
			const temPF = {
				[dataMap.PLATFORM_DY.value]: dataMap.PLATFORM_DY.label + '号',
				[dataMap.PLATFORM_KS.value]: dataMap.PLATFORM_KS.label + '号/ID',
			};
			return temPF[this.platformId] || '';
		},
		filters() {
			const { dyList, ksList, spList } = this;
			const temPF = {
				[dataMap.PLATFORM_DY.value]: dyList,
				[dataMap.PLATFORM_KS.value]: ksList,
				[dataMap.PLATFORM_SP.value]: spList,
			};
			let cateList = temPF[this.platformId] || [];
			cateList = [{ value: '', label: '不限' }, ...cateList];
			const temPF_name = {
				[dataMap.PLATFORM_DY.value]: '商品类目',
				[dataMap.PLATFORM_KS.value]: '商品类目',
				[dataMap.PLATFORM_SP.value]: '账号分类',
			};
			return [
				{
					label: temPF_name[this.platformId] || '',
					key: 'cate',
					list: cateList,
					show: true,
				},
			];
		},
	},
	methods: {
		async clueSelectList() {
			const { code, data } = await clueSelectList({ platformId: this.platformId });
			if (code != 0) return;
			this.liveSale = data.liveSale || [];
			this.avgPrice = data.avgPrice || [];
			this.fee30 = data.fee30 || [];
			this.fansNum = data.fansNum || [];
			this.videoSale = data.videoSale || [];
			this.promotionProNum = data.promotionProNum || [];
		},
		select(key, value) {
			if (this.form[key] === value) return;
			this.form[key] = value;
		},
		expand(key) {
			this.expands[key] = !this.expands[key];
			this.$refs[key][0].scrollTo(0, 0);
		},
		submit(isInit) {
			const form = { ...this.form };
			if (this.selectOption == 2) {
				form.anchor_account = form.anchor_name;
				form.anchor_name = '';
			}
			let formCopy = {};
			Object.keys(form).forEach(key => {
				formCopy[key] = Array.isArray(form[key]) ? form[key].join(',') : form[key];
			});
			this.$emit('submit', formCopy, isInit);
		},
		reset() {
			this.form = {
				cate: '',
				fans_num: '',
				fans_age: '',
				fans_sex: '',
				fans_city_level: '',
				anchor_level: -1,
				live_sale: '',
				live_count_90: '',
				avg_price: '',
				anchor_name: '',
				anchor_account: '',
				team_claim: 0,
				partner_claim: 0,
				promotion_pro_num: '',
				fee_30: '',
			};
			this.submit(true);
		},
		handleCommand(e) {
			const { isCooperation } = this;
			this.dropdownText = e === '0' ? '团队未合作' : '本人未合作';
			this.content = e === '0' ? '一键筛选团队所有成员均未认领的达人' : '一键筛选团队商务本人未认领的达人';
			if (isCooperation) this.handleCheck(isCooperation);
		},
		handleCheck(e) {
			const { dropdownText } = this;
			if (dropdownText === '团队未合作') {
				this.form.team_claim = Number(e);
				this.form.partner_claim = 0;
			} else {
				this.form.partner_claim = Number(e);
				this.form.team_claim = 0;
			}
			this.submit(true);
		},
		async getPartnerAnchor() {
			const { platformId: platform_id } = this;
			const { code, data: { many_partner } = {} } = await getPartnerAnchor({ platform_id });
			if (code !== 0) return;
			this.many_partner = many_partner;
		},
	},
};
</script>
<style lang="less" scoped>
.filters-box {
	width: 100%;
}
.filter-item {
	width: 100%;
	display: flex;
	padding: 8px 0;
	box-sizing: border-box;
	&.center {
		align-items: center;
	}
	.label {
		width: 60px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		color: #86909d;
		text-align: right;
		padding-right: 40px;
		line-height: 24px;
		flex-shrink: 0;
	}
}
.filter-box {
	display: flex;
	flex: 1;
	height: 23px;
	flex-wrap: wrap;
	overflow: hidden;
	&.expand-all {
		height: 56px;
		overflow-y: auto;
		&::-webkit-scrollbar {
			display: none;
		}

		.item-name {
			margin-bottom: 8px;
		}
	}
	.el-select {
		margin-right: 8px;
		width: 150px;
		::v-deep {
			&.el-input__inner {
				height: 24px;
			}
			& > .el-input {
				font-size: 14px;
			}
			&.el-input__icon {
				line-height: 24px;
			}
		}
	}
}
.item-name {
	padding-right: 40px;
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #333;
	cursor: pointer;
	&.active {
		color: @color-primary;
	}
	&:hover {
		color: @color-primary;
	}
}
.more {
	margin-left: 20px;
	height: 20px;
	display: flex;
	align-items: center;
	font-size: 12px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #606265;
	&:hover {
		color: @color-primary;
	}
	i {
		margin-left: 2px;
		transform: rotate(0);
		transition: all 0.3s;
	}
	cursor: pointer;
	&.expand {
		i {
			transform: rotate(180deg);
		}
	}
}
::v-deep .el-input-group__prepend {
	background-color: #fff;
	border-color: #e3e3e3;
	.el-select {
		margin: -10px -20px;
		width: 120px;
	}
}
</style>
